<template>
  <form autocomplete="off" class="">
    <div class="row justify-content-center">
        <div class="col-lg-12">
            <div class="card bg-light">
                <div class="card-body">
                    <div class="row gy-3">
                        <div class="col-lg-12">
                            <label class="form-label">Marital Status <span class="text-danger">*</span></label>
                            <select v-model="data.marital_status" name="marital_status" class="form-select"
                            :class="{ 'is-invalid': v$.data.marital_status.$error }" >
                            <option disabled value="" >--select status--</option>
                            <option v-for="(mastatus, gdIndex) in maritalOptions" :key="gdIndex" 
                                :value="mastatus.value">{{mastatus.label}}</option>
                            </select>
                            <div v-for="(item, index) in v$.data.marital_status.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-grid d-sm-block mb-3 mb-sm-0 order-sm-2">
                <button @click.prevent="confirm()" class="btn btn-primary"  type="button">
                    Update Status
                </button>
            </div>
        </div>
    </div>
  </form>
</template>

<script>
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import IsLoading from '@/components/IsLoading.vue'

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        IsLoading,
    },
    props:{
        editItem:{
            type: Object,
            default: null
        }
    },
    data(){
        return{
          isLoading: false,
          data: {
            marital_status: ""
          },
          maritalOptions:[
            { label: 'Single', value: 'Single' },
            { label: 'Married', value: 'Married' },
            { label: 'Widowed', value: 'Widowed' },
            { label: 'Divorced', value: 'Divorced' },
          ],
          mirrorData: null,
        }
    },
    validations() {
        return {        
          data:{
            marital_status: {
                required: helpers.withMessage("Select marital status", required),
            },   
          }
        }
    },
    computed: {
        activeUser(){
            return this.$store.state.AppActiveUser
        },
    },
    methods:{
        async confirm() {
          const result = await this.v$.$validate();
          if (!result) {
              this.alertError(this.v$.$errors[0].$message);
              return;
          }
          const confirmResult = await this.confirmAction({
              html: "<h6>Acknowledge that the status is accurate.</h6>",
          });
          if (confirmResult.value) {
              this.create();
          }
        },
        create() {
            this.$store.dispatch("changeLoaderValue", true)
            this.$http.post('/account/update-marital-status', this.data)
            .then((response) => {
                this.$store.dispatch("changeLoaderValue", false)
                if(response.data.success){
                    this.$emit('addItem', response.data.data)
                    this.resetForm();
                }
            })
        },
        resetForm(){
            this.data = {...this.mirrorData}
            this.v$.$reset()
            this.$emit("closeMe")
        },
        getOptionData(){
           
        },
    },
    created(){
        this.getOptionData()
    },
    mounted(){
        this.mirrorData = JSON.parse(JSON.stringify(this.data))
    }
}
</script>

<style scoped>
</style>